import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';
import { SnapshotDataType } from 'types/snapshot';

import { resolveSnapshotActor } from './helpers';

const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const Postfix = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
  color: inherit;
`;

interface Props {
  snapshot: SnapshotDataType;
  separator?: boolean;
  showTooltip?: boolean;
}

const SnapshotActor = ({ snapshot, separator = true, showTooltip = false }: Props) => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const label = resolveSnapshotActor(currentUser, snapshot);

  return (
    <Container>
      {separator && <span>·</span>}
      <Postfix>{label}</Postfix>
    </Container>
  );
};

export default SnapshotActor;
